module.exports = __webpack_public_path__ + "img/logo_s3_fold.602a8569.svg";